export const DMQStepNames = {
  PERSONAL_DETAILS: "Personal Details",
  ADDRESS_DETAILS: "Address Details",
  GENERAL_HISTORY: "General Health Questions",
  MEDICAL_HISTORY: "Medical History",
  INSURANCE_HISTORY: "Insurance & Medical History",
  DECLARATION: "Declaration",
  NRI_QUESTIONNAIRE: "NRI Questionnaire",
  FOREIGN_NATIONAL_QUESTIONNAIRE: "Foreign National Questionnaire",
  DIABETIC_QUESTIONNAIRE: "Diabetes Questionnaire",
  BLOOD_PRESSURE_QUESTIONNAIRE: "High BP Questionnaire",
  KIDNEY_QUESTIONNAIRE: "Kidney Questionnaire",
  THYROID_QUESTIONNAIRE: "Thyroid Questionnaire",
};

export const MAIN_STEPS = {
  PERSONAL_DETAILS: "Personal_Details",
  MEDICAL_HISTORY: "Medical_History",
  NRI_QUESTIONNAIRE: "NRI_Details",
  FOREIGN_NATIONAL_QUESTIONNAIRE: "Foreign_National_Details",
  DIABETIC_QUESTIONNAIRE: "Diabetic_Details",
  BLOOD_PRESSURE_QUESTIONNAIRE: "Blood_Pressure_Details",
  KIDNEY_QUESTIONNAIRE: "Kidney_Details",
  THYROID_QUESTIONNAIRE: "Thyroid_Details",
  CONFIRM_DETAILS: "Confirm_Details",
};

export const Questionnaires = {
  PRIMARY_QUESTIONNAIRE: process.env.REACT_APP_PRIMARY_QUESTIONNAIRE.toString(),
  DIABETIC_QUESTIONNAIRE: process.env.REACT_APP_DIABETES_QUESTIONNAIRE.toString(),
  BLOOD_PRESSURE_QUESTIONNAIRE: process.env.REACT_APP_HIGHBP_QUESTIONNAIRE.toString(),
  THYROID_QUESTIONNAIRE: process.env.REACT_APP_THYROID_QUESTIONNAIRE.toString(),
  KIDNEY_QUESTIONNAIRE: process.env.REACT_APP_KIDNEY_QUESTIONNAIRE.toString(),
  NRI_QUESTIONNAIRE: process.env.REACT_APP_NRI_QUESTIONNAIRE.toString(),
  FOREIGN_NATIONAL_QUESTIONNAIRE: process.env.REACT_APP_FOREIGN_NATIONAL_QUESTIONNAIRE.toString(),
};
